const ClosedSrc = () => {
  return (
    <div className="tag noSrc">
      <span className="tagText">Source Unavailable</span>
    </div>
  );
};

export default ClosedSrc;
